import ScrollDownButton from './components/scrollDownButton/scrollDownButton';
import Toggles from './components/toggles/toggles';
import Representatives from './pages/representatives/representatives';
import ContactUs from './pages/contactUs/contactUs';
import ContactForm from './components/contactForm/contactForm';
import News from './pages/news/news';
import ManagementSolutions from './pages/managementSolutions/managementSolutions';
import FileArchive from './pages/fileArchive/fileArchive';
import ProductOverview from './components/productOverview/productOverview';
import Product from './pages/product/product';
import ResponsiveMenu from './components/responsiveMenu/responsiveMenu';
import ResponsiveSearch from './components/responsiveSearch/responsiveSearch';
import LanguageSelector from './components/languageSelector/languageSelector';
import TopSection from './components/topSection/topSection';
import MechrailOverview from './components/mechrailOverview/mechrailOverview';
import AboveHeader from './layout/aboveHeader/aboveHeader';
import Search from './pages/search/search';
import { initCopyEventGtm } from './utils/helpers';
import RelatedProducts from './components/relatedProducts/relatedProducts.js';
require('./components/logoSlider/logoSlider');
require('./components/videoHolder/videoHolder');

if (document.querySelector('.productData__inner') !== null) {
    require('./pages/product/productData.js');
}

if (document.querySelector('.cardSlider') !== null) {
    require('./components/cardSlider/cardSlider.js');
}

if (document.querySelector('.historySlider') !== null) {
    require('./components/historySlider/historySlider.js');
}

initCopyEventGtm();

export default class App {
    constructor() {
        this.page = this.initPage();
        this.initComponents();
    }

    initPage() {
        if (
            document.body.classList.contains(
                'page-template-tpl-representatives'
            )
        ) {
            return new Representatives();
        } else if (
            document.body.classList.contains('page-template-tpl-contact')
        ) {
            return new ContactUs();
        } else if (document.body.classList.contains('blog')) {
            return new News();
        } else if (document.body.classList.contains('home')) {
            this.productOverview = new ProductOverview();
        } else if (
            document.body.classList.contains('single-product') ||
            document.body.classList.contains('tax-product_category')
        ) {
            return new Product();
        } else if (
            document.body.classList.contains(
                'post-type-archive-management_solutions'
            )
        ) {
            return ManagementSolutions.initArchive();
        } else if (
            document.body.classList.contains(
                'search'
            )
        ) {
            return new Search();
        } else if (document.body.classList.contains('post-type-archive-file')
        ) {
            return FileArchive.initArchive();
        }
    }

    initComponents() {
        this.scrollDownButton = this.initScrollDownButton();
        this.toggles = this.initToggles();
        this.contactForm = this.initContactForm();
        this.responsiveMenu = new ResponsiveMenu();
        this.languageSelector = new LanguageSelector();
        this.topSection = new TopSection();
        this.mechrailOverview = this.initMechrailOverview();
        this.wrapIframes();
        this.aboveHeader = new AboveHeader();
        this.responsiveSearch = new ResponsiveSearch();
        this.relatedProducts = this.initRelatedProducts();
    }

    initToggles() {
        const elements = document.querySelectorAll('.toggles');
        const toggles = [];

        for (let i = 0; i < elements.length; i++) {
            toggles.push(new Toggles(elements[i]));
        }

        return toggles;
    }

    initContactForm() {
        const form = document.querySelector('.contactForm');
        if (!form) {
            return false;
        }

        return new ContactForm(form);
    }

    initScrollDownButton() {
        const scrollDownButton = document.querySelector('.scrollDownButton');
        if (!scrollDownButton) {
            return false;
        }

        return new ScrollDownButton();
    }

    initMechrailOverview() {
        const mechrailOverview = document.querySelector('.mechrailOverview');
        if (!mechrailOverview) {
            return false;
        }

        return new MechrailOverview();
    }

    initRelatedProducts() {
        const relatedProducts = document.querySelector('.relatedProducts');
        if (!relatedProducts) {
            return false;
        }

        return new RelatedProducts();
    }

    wrapIframes() {
        const iframes = document.querySelectorAll('iframe');

        for (var i = 0; i < iframes.length; i++) {
            const wrapper = document.createElement('div');
            wrapper.classList.add('embedContainer');
            iframes[i].parentNode.appendChild(wrapper);
            wrapper.appendChild(iframes[i]);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app.js